<h2 mat-dialog-title>Sort</h2>
<mat-dialog-content>
  <!-- Allow sorting by Version Name or Store Name -->
  <mat-radio-group [(ngModel)]="sortBy">
    <mat-radio-button value="VersionName">Version Name</mat-radio-button>
    <mat-radio-button value="ClientKey">Client Key</mat-radio-button>
  </mat-radio-group>

  <div class="direction-toggle">
    <button mat-button [color]="sortDirection === 'asc' ? 'primary' : ''"
            (click)="sortDirection = 'asc'">
      <mat-icon>arrow_upward</mat-icon> Ascending
    </button>
    <button mat-button [color]="sortDirection === 'desc' ? 'primary' : ''"
            (click)="sortDirection = 'desc'">
      <mat-icon>arrow_downward</mat-icon> Descending
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="accent" (click)="onApply()">Apply</button>
</mat-dialog-actions>
